import { Observable } from 'rxjs';
import { System } from 'common/systems/domain/resources/system.resource';

/**
 * Initial-fetch port for the `systems` capability. Implementations live in
 * infrastructure (e.g. wrapping the legacy `SystemsService`); `common/`
 * consumers must depend only on this abstract class, never on a concrete
 * infrastructure/service or on Angular.
 */
export abstract class SystemsRepositoryPort {
    public abstract getAll(): Observable<ReadonlyArray<System>>;
}
